module.exports = __webpack_public_path__ + "media/mascot/mascot7-3a8cbf34.png";